export interface Task {
  id?: string;
  userId: string;
  type: TaskType;
  status: TaskStatus;
  started: string; // ISO string format for LocalDateTime
  finished?: string; // ISO string format for LocalDateTime, optional
  description: string;
}

export enum TaskType {
  // Add your specific task types here
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  PROCESSING = 'PROCESSING',
  VALIDATION = 'VALIDATION'
}

export enum TaskStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  WARNING = 'WARNING'
}

// Optional: DTO interface that matches the Java TaskDto structure
export interface TaskDto {
  id: string;
  userId: string;
  started?: string;
  type: string;
  status: string;
  description: string;
  finished?: string;
}


export interface TaskLogsDTO {
    messages: LogEvent[];
    lastTimestamp: string;
    moreLogs: boolean;
}

export interface LogEvent {
    id?: string;
    taskId: string;
    date: string;
    message: string;
    source?: string;
    level: LogLevel;
}

export enum LogLevel {
  INFO = 'INFO',
  WARN = 'WARNING',
  ERROR = 'ERROR'
}
